import React, { Component, Fragment } from 'react';
import { inject, observer } from 'mobx-react';
import { Modal, Row, Col, Input, InputNumber, Button, DatePicker, Alert } from 'antd';
import moment from 'moment';

import './UpsertMaintenanceModal.css';
import { api } from '../../../services';

// These modals can be opened from inside QuickDataModal (the maintenances
// history dialog), which uses the antd default z-index of 1000. With equal
// z-indexes the stacking depends on the order rc-dialog appended the portals to
// <body> (i.e. on which modal the user happened to open first), so nest them
// explicitly above it. Stays below antd's popover/dropdown layers (1030/1050).
export const NESTED_MODAL_Z_INDEX = 1020;

@inject('translationsStore', 'commonStore')
@observer
export default class UpsertMaintenanceModal extends Component {
  constructor(props) {
    super(props);
    this.defaultValues = this.buildDefaultValues();
    this.state = {
      modalUpsertLoading: false,
      modalCanUpsert: false,
      modalUpsertDescription: this.defaultValues.description,
      modalUpsertKm: this.defaultValues.km,
      modalUpsertMoment: this.defaultValues.moment,
      modalUpsertDate: this.defaultValues.date,
      error: null
    };
  }

  componentDidUpdate(prevProps) {
    const prevId = prevProps.maintenance ? prevProps.maintenance.id : null;
    const currentId = this.props.maintenance ? this.props.maintenance.id : null;
    if (prevId !== currentId) {
      this.syncFromMaintenance();
    }
  }

  // km e date possono arrivare null dal backend: senza guardia moment(null) e'
  // un moment invalido (il DatePicker mostra "Invalid date") e i confronti con
  // '' in checkProcessing/updateMaintenance non scattano.
  buildDefaultValues() {
    const { maintenance } = this.props;
    const description = maintenance && maintenance.description ? maintenance.description : '';
    const km = maintenance && maintenance.km !== null && maintenance.km !== undefined ? maintenance.km : '';
    const date = maintenance && maintenance.date ? maintenance.date : '';
    return {
      description,
      km,
      moment: date !== '' ? moment(date, 'YYYY-MM-DD') : null,
      date
    };
  }

  syncFromMaintenance = () => {
    this.defaultValues = this.buildDefaultValues();
    this.setState({
      modalUpsertDescription: this.defaultValues.description,
      modalUpsertKm: this.defaultValues.km,
      modalUpsertMoment: this.defaultValues.moment,
      modalUpsertDate: this.defaultValues.date,
    });
  };

  onDescriptionChange = e => {
    this.setState({ modalUpsertDescription: e.target.value }, () => {
      this.checkProcessing();
    });
  };

  onKmChange = e => {
    const { modalUpsertKm: prevValue } = this.state;
    let value = e.target.value.trim() === '' ? '' : isNaN(e.target.value) ? prevValue : parseInt(e.target.value, 10);
    this.setState({ modalUpsertKm: value }, () => {
      this.checkProcessing();
    });
  };

  onDateChange = (date, dateString) => {
    const newDate = date !== null ? date.format('YYYY-MM-DD') : '';
    this.setState({ modalUpsertMoment: date, modalUpsertDate: newDate }, () => {
      this.checkProcessing();
    });
  };

  checkProcessing = () => {
    const { modalUpsertDescription, modalUpsertKm, modalUpsertDate } = this.state;
    const modalCanUpsert = modalUpsertDescription !== '' && (modalUpsertDate !== '' || modalUpsertKm !== '');
    this.setState({ modalCanUpsert });
  };

  addMaintenance = () => {
    this.setState({ modalCanUpsert: false, modalUpsertLoading: true });
    const { carId, onOk, onError } = this.props;
    let { modalUpsertDescription: description, modalUpsertKm: km, modalUpsertDate: date } = this.state;
    km = km !== '' ? km : undefined;
    date = date !== '' ? date : undefined;
    api('addMaintenance', { carId, description, km, date })
      .then(response => {
        this.setState(
          {
            modalUpsertLoading: false,
            modalCanUpsert: false,
            modalUpsertDescription: this.defaultValues.description,
            modalUpsertKm: this.defaultValues.km,
            modalUpsertMoment: this.defaultValues.moment,
            modalUpsertDate: this.defaultValues.date,
            error: null
          },
          () => {
            onOk instanceof Function && onOk(response);
          }
        );
      })
      .catch(error => {
        this.setState(
          {
            modalUpsertLoading: false,
            modalCanUpsert: true,
            error: error
          },
          () => {
            onError instanceof Function && onError(error);
          }
        );
      });
  };

  updateMaintenance = () => {
    this.setState({ modalCanUpsert: false, modalUpsertLoading: true });
    const { carId, onOk, onError } = this.props;
    let { modalUpsertDescription: description, modalUpsertKm: km, modalUpsertDate: date } = this.state;
    km = km !== '' ? km : null;
    date = date !== '' ? date : null;
    api('updateMaintenance', { maintenanceId: this.props.maintenance.id, carId, description, km, date })
      .then(response => {
        this.setState(
          {
            modalUpsertLoading: false,
            modalCanUpsert: false,
            modalUpsertDescription: this.defaultValues.description,
            modalUpsertKm: this.defaultValues.km,
            modalUpsertMoment: this.defaultValues.moment,
            modalUpsertDate: this.defaultValues.date,
            error: null
          },
          () => {
            onOk instanceof Function && onOk(response);
          }
        );
      })
      .catch(error => {
        this.setState(
          {
            modalUpsertLoading: false,
            modalCanUpsert: true,
            error: error
          },
          () => {
            onError instanceof Function && onError(error);
          }
        );
      });
  }

  cancel = () => {
    const { onCancel } = this.props;
    onCancel instanceof Function && onCancel();
  };

  render() {
    const { translationsStore, commonStore } = this.props;
    return this.props.carId ? (
      <Modal
        {...this.props}
        className={`UpsertMaintenanceModal ${this.props.className}`}
        visible={this.props.visible}
        onCancel={this.cancel}
        onOk={this.props.maintenance ? this.updateMaintenance : this.addMaintenance}
        title={translationsStore.translate(this.props.maintenance ? 'editMaintenances.modal.title' : 'newMaintenances.modal.title')}
        width="calc(var(--tablet-width) / var(--modal-width-ratio))"
        getContainer={() => document.getElementById('MaintenanceCard')}
        centered={true}
        zIndex={NESTED_MODAL_Z_INDEX}
        footer={[
          <Button key="cancel" onClick={this.cancel}>
            {translationsStore.translate('newMaintenances.modal.cancel')}
          </Button>,
          <Button key="ok" type="primary" loading={this.state.modalUpsertLoading} onClick={this.props.maintenance ? this.updateMaintenance : this.addMaintenance} disabled={!this.state.modalCanUpsert}>
            OK
          </Button>
        ]}
        destroyOnClose
      >
        <Fragment>
          <Row style={{ marginBottom: 20 }}>
            <Col span={12}>{translationsStore.translate('newMaintenances.modal.labelDescription')}</Col>
            <Col span={12}>
              <Input
                value={this.state.modalUpsertDescription}
                onChange={this.onDescriptionChange}
                placeholder={translationsStore.translate('newMaintenances.modal.labelDescription')}
              />
            </Col>
          </Row>
          <Row style={{ marginBottom: 20 }}>
            <Col span={12}>{translationsStore.translate('newMaintenances.modal.labelKm')}</Col>
            <Col span={12}>
              <InputNumber
                value={this.state.modalUpsertKm}
                onKeyUp={this.onKmChange}
                placeholder={translationsStore.translate('newMaintenances.modal.labelKm')}
                style={{ width: 171 }}
              />
            </Col>
          </Row>
          <Row style={{ marginBottom: 20 }}>
            <Col span={12}>{translationsStore.translate('newMaintenances.modal.labelDate')}</Col>
            <Col span={12}>
              <DatePicker
                showToday={true}
                format={commonStore.longDateFormat.L}
                value={this.state.modalUpsertMoment}
                onChange={this.onDateChange}
                disabledDate={currentDate => moment(currentDate).isBefore(moment(new Date()).subtract(1, 'day'))}
              />
            </Col>
          </Row>
          {this.state.error && (
            <Alert
              message={translationsStore.translate('newMaintenances.modal.genericError')}
              type="error"
              showIcon
              style={{ marginBottom: 20 }}
            />
          )}
        </Fragment>
      </Modal>
    ) : (
      <Fragment />
    );
  }
}
